import React, { useCallback } from 'react';
import { all, identity, isEmpty, map, pipe, toPairs, values } from 'ramda';
import { Icon } from 'js/components/common/Icon';
import { Button } from 'js/components/common/Button';
import { useShowNotification } from 'js/components/common/Notifications';
import { usePortletSelector, usePortletTranslations } from 'js/components/system/Portlet';

import List from './List';
import { setContactPreferences, updateUserContactPreferences } from './actions';

import style from './index.scss';

const initialNotification = {
    Icon: <Icon type="contactUs" className={style.iconNotification} />
};

export const lists = [
    { type: 'promotional' },
    { type: 'account' },
    { type: 'thirdParty', withToggles: false }
];

export const isAllEmpty = pipe(
    values,
    all(isEmpty)
);

export const parse = {
    promotional: identity,
    thirdParty: identity,
    account: map(item => ({ ...item, preference: !item.preference }))
};

export const refinePreferences = pipe(
    toPairs,
    map(([k, v]) => parse[k](v)),
    list => [].concat(...list)
);

export default ({ onSubmit = identity }) => {
    const preferences = usePortletSelector();
    const t = usePortletTranslations();
    const showNotification = useShowNotification(initialNotification);
    const getNotification = useCallback((type) => ({ message: t(type) }), [t]);

    const handleSubmit = useCallback(async (e) => {
        try {
            const refined = refinePreferences(preferences);

            e.preventDefault();

            await setContactPreferences(refined);
            updateUserContactPreferences(refined);
            onSubmit();
            showNotification(getNotification('success'));
        } catch (err) {
            showNotification(getNotification('error'));
        }

    }, [getNotification, onSubmit, preferences, showNotification]);

    return !isAllEmpty(preferences) && <form className={style.container} onSubmit={handleSubmit}>
        {lists.map((item, index) => <List key={index} {...item} />)}

        <div className={style.rowButton}>
            <Button type="submit" className={style.button}>
                {t('submit')}
            </Button>
        </div>
    </form>;
};
